import { Box, Button, Stack, Checkbox } from "@mui/material";
import { DataGrid, GridColDef, GridCellParams } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useDeletePageMasterMutation } from "../../../store/feature/service/PageMaster";

const PageAccessTableCreate = ({
  data,
  dataPgeAccess,
  params,
  setParams,
}: any) => {
  const navigate = useNavigate();
  const [deletePageMaster] = useDeletePageMasterMutation();

  // STATE TO HANDLE ROW SELECTION
  const [rowSelection, setRowSelection] = useState<any>({});

  // Initialize checkbox states
  useEffect(() => {
    if (data?.data) {
      const initialState = data.data.reduce((acc: any, row: any) => {
        // If we have existing data (update mode), use it
        const existingData = dataPgeAccess?.data?.find(
          (item: any) => item.pge_master_uid === row.pge_master_uid
        );

        acc[row.pge_master_uid] = existingData 
          ? {
              create: existingData.adm_pge_role_create === 1,
              read: existingData.adm_pge_role_read === 1,
              update: existingData.adm_pge_role_update === 1,
              delete: existingData.adm_pge_role_delete === 1,
            }
          : {
              create: false,
              read: false,
              update: false,
              delete: false,
            };
        
        return acc;
      }, {});

      setRowSelection(initialState);
      
      // Update params with initial state
      const selectedRows = Object.entries(initialState).map(
        ([uid, fields]: any) => ({
          adm_pge_role_create: fields.create ? 1 : 0,
          adm_pge_role_delete: fields.delete ? 1 : 0,
          adm_pge_role_read: fields.read ? 1 : 0,
          adm_pge_role_update: fields.update ? 1 : 0,
          pge_master_uid: uid,
        })
      );
      setParams(selectedRows);
    }
  }, [data, dataPgeAccess]);

  const handleCheckboxChange = (event: any, row: any, field: string) => {
    const { checked } = event.target;
    setRowSelection((prev: any) => {
      const updatedSelection = {
        ...prev,
        [row.uid]: {
          ...prev[row.uid],
          [field]: checked,
        },
      };

      // Update params when checkboxes change
      const selectedRows = Object.entries(updatedSelection).map(
        ([uid, fields]: any) => ({
          adm_pge_role_create: fields.create ? 1 : 0,
          adm_pge_role_delete: fields.delete ? 1 : 0,
          adm_pge_role_read: fields.read ? 1 : 0,
          adm_pge_role_update: fields.update ? 1 : 0,
          pge_master_uid: uid,
        })
      );
      setParams(selectedRows);

      return updatedSelection;
    });
  };

  const columns: GridColDef[] = [
    {
      field: "pageName",
      headerName: "Page Name",
      flex: 3,
      minWidth: 500,
      headerClassName: "centered",
    },
    {
      field: "create",
      headerName: "Create",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 250,
      renderCell: (params: GridCellParams) => (
        <Checkbox
          checked={rowSelection[params.row.uid]?.create || false}
          onChange={(e) => handleCheckboxChange(e, params.row, "create")}
        />
      ),
    },
    {
      field: "read",
      headerName: "Read",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 250,
      renderCell: (params: GridCellParams) => (
        <Checkbox
          checked={rowSelection[params.row.uid]?.read || false}
          onChange={(e) => handleCheckboxChange(e, params.row, "read")}
        />
      ),
    },
    {
      field: "update",
      headerName: "Update",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 250,
      renderCell: (params: GridCellParams) => (
        <Checkbox
          checked={rowSelection[params.row.uid]?.update || false}
          onChange={(e) => handleCheckboxChange(e, params.row, "update")}
        />
      ),
    },
    {
      field: "delete",
      headerName: "Delete",
      headerAlign: "center",
      align: "center",
      flex: 1,
      minWidth: 250,
      renderCell: (params: GridCellParams) => (
        <Checkbox
          checked={rowSelection[params.row.uid]?.delete || false}
          onChange={(e) => handleCheckboxChange(e, params.row, "delete")}
        />
      ),
    },
  ];

  useEffect(() => {
    if (dataPgeAccess) {
      // console.log('dataPgeAccess ===> ', JSON.stringify(dataPgeAccess?.data))
    }
  }, [dataPgeAccess]);

  // Initialize rows based on data
  // console.log("data haha ==>  ", data);
  const rows =
    data?.data?.map((row: any, index: any) => ({
      id: index,
      uid: row.pge_master_uid,
      pageName: row.pge_master_name,
    })) || [];

  return (
    <Box sx={{ height: "450px" }}>
      {rowSelection && (
        <DataGrid
          rows={rows}
          columns={columns}
          disableColumnMenu
          hideFooter
          disableColumnSelector
          disableDensitySelector
          disableSelectionOnClick
        />
      )}
    </Box>
  );
};

export default PageAccessTableCreate;
